import {getAuthSessionVersion} from 'src/store/auth/session';

export type DisplaySettings={terminal_id:string;terminal_name:string;time_zone:string;hour_cycle:'h23'|'h12';version:number};
let value:DisplaySettings|null=null;
let owner=-1;
export function clearDisplaySettings(){value=null;owner=-1;}
export function setDisplaySettings(data:DisplaySettings,session:number){
  if(session!==getAuthSessionVersion())return;
  if(!data||typeof data.terminal_id!=='string'||!data.terminal_id||typeof data.terminal_name!=='string'||!data.terminal_name||typeof data.time_zone!=='string'||!data.time_zone||!['h23','h12'].includes(data.hour_cycle)||!Number.isInteger(data.version)||data.version<0)throw new Error('Настройки времени не подтверждены');
  new Intl.DateTimeFormat('ru-RU',{timeZone:data.time_zone}).format(0);
  value=Object.freeze({...data});owner=session;
}
export function getDisplaySettings():DisplaySettings{
  if(!value||owner!==getAuthSessionVersion())throw new Error('Часовой пояс терминала не загружен');
  return value;
}
